import React from 'react';
import { Flex } from '@chakra-ui/react';
import { NAVIGATION_HEIGHT } from '../Navigation/MobileNavigation/MobileNavigation';
import { colorsGrey } from '@src/theme/chakraTheme/colors';

const SearchResultWrapper: FCWithChildren = ({ children }) => (
  <Flex
    direction="column"
    mt={NAVIGATION_HEIGHT}
    h={`calc(100vh - ${NAVIGATION_HEIGHT})`}
    bgColor={colorsGrey[50]}
  >
    {children}
  </Flex>
);

export default SearchResultWrapper;
